import { UserModel, CustomerAccountUserClient, UserLoginDetails } from "@/Generated/ParticaAPI";

export interface IUserService {
	getUsers(accountId: number): Promise<UserLoginDetails[]>;
}

export class UserService implements IUserService {
	private svc: CustomerAccountUserClient = new CustomerAccountUserClient();

	public async getUsers(accountId: number): Promise<UserLoginDetails[]> {
		return this.svc.getUsers(accountId);
	}
}
